// extracted by mini-css-extract-plugin
export default {"selector":"selector_selector__KUB+s","item":"selector_item__tbvxC"};